module.exports = __webpack_public_path__ + "static/media/2.04986475.jpg";